import script from "./_empty-profile-banner.vue?vue&type=script&setup=true&lang=js"
export * from "./_empty-profile-banner.vue?vue&type=script&setup=true&lang=js"

import "./_empty-profile-banner.vue?vue&type=style&index=0&id=48569e00&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48569e00"]])

export default __exports__